import { useLocation } from 'react-router-dom'
import { Hammer } from 'lucide-react'
import Card from '../components/Card'
import PageHeader from '../components/PageHeader'
import { EmptyState } from '../components/States'
import { findMenuEntry } from './navigation'
import { shell } from './strings'

/**
 * Scaffolding for routes whose page has not been redesigned yet, so every side-menu
 * destination resolves while the phases land one at a time. Each page replaces this
 * with its own cloned screen; nothing here is legacy content.
 */
export default function PlaceholderPage({ title }) {
  const { pathname } = useLocation()
  const entry = findMenuEntry(pathname)
  const heading = title ?? entry?.item.title ?? ''

  return (
    <>
      <PageHeader title={heading} subtitle={entry?.group.title} />
      <Card>
        <EmptyState
          icon={Hammer}
          title={shell.placeholderTitle}
          description={shell.placeholderDesc}
        />
      </Card>
    </>
  )
}
